import queryString from 'query-string'
import { usingGet, usingPost } from '@ocean/api'
import { StaRedirectParams } from 'core/staIntegration/types'

export const getLegacyMenuConfiguration = () =>
  usingGet('environment/legacyMenuConfiguration', { useProxy: true })

export const getStaRedirectLink = (redirectParams?: StaRedirectParams) => {
  const baseUrl = 'legacySta/redirectLink'

  if (!redirectParams) {
    return usingGet(baseUrl, { useProxy: true })
  }

  const redirectQueryParams = queryString.stringify(redirectParams, {
    skipNull: true,
  })

  return usingGet(`${baseUrl}?${redirectQueryParams}`, { useProxy: true })
}

export const invokeCesSilentPusher = (data: string) =>
  usingPost(
    'legacySta/pushCesData',
    {
      data,
    },
    { useProxy: true }
  )

export const invokeAproSilentPusher = (data: string) =>
  usingPost(
    'legacySta/pushAproData',
    {
      data,
    },
    { useProxy: true }
  )
